// going to need the data to render the preview template. hopefully this is JUST grabbing the HTML and stuffing it in here
// should just need a get request to the API to do the thang here.

import React, { useEffect, useRef, useState } from "react";

import { getPreviewInvite } from "../api";
import { useParams } from "react-router-dom";

export const PreviewTemplate = () => {
  const { inviteId, password } = useParams();
  console.log("params:", useParams());
  const [previewLinkData, setPreviewLinkData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const iframeRef = useRef(null);

  const isExpired =
    (previewLinkData?.expired_when &&
      new Date(previewLinkData.expired_when).getTime() <= Date.now()) ||
    previewLinkData?.expired ||
    previewLinkData?.is_expired;

  useEffect(() => {
    if (loading) return;
    const previousTitle = document.title;
    if (isExpired) {
      document.title = "Preview Link Expired";
    } else if (previewLinkData?.subject) {
      document.title = previewLinkData.subject;
    }
    return () => {
      document.title = previousTitle;
    };
  }, [loading, isExpired, previewLinkData]);

  useEffect(() => {
    const fetchPreviewInvite = async () => {
      setLoading(true);
      try {
        if (inviteId && password) {
          const response = await getPreviewInvite({
            id: inviteId,
            password: password,
          });
          console.log("Response:", response);
          if (response.data) {
            setPreviewLinkData(response.data);
          } else {
            setError("No data found for the provided invite ID and Password.");
          }
        }
      } catch (error) {
        console.error("Error fetching preview invite:", error);
        // For network errors (CORS) or 400 errors, assume it's an expired invite
        setPreviewLinkData({
          expired_when: new Date().toISOString(),
          expired: true,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchPreviewInvite();
  }, [inviteId, password]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return (
      <div
        className="alert alert-warning"
        style={{
          display: "block",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        {error}
      </div>
    );
  }

  const resizeIframe = () => {
    const doc = iframeRef.current?.contentDocument;
    if (doc?.documentElement) {
      iframeRef.current.style.height = `${doc.documentElement.scrollHeight}px`;
    }
  };

  if (isExpired) {
    return (
      <div
        className="alert alert-warning"
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          textAlign: "center",
        }}
      >
        <p>This preview link has expired.</p>
        <p>Please ask the person who sent it to you for a new link.</p>
      </div>
    );
  }

  if (previewLinkData?.preview_html) {
    return (
      <iframe
        ref={iframeRef}
        title={previewLinkData.subject || "Email preview"}
        srcDoc={withLinksInNewTab(previewLinkData.preview_html)}
        sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        onLoad={resizeIframe}
        style={{
          display: "block",
          width: "100%",
          minHeight: "100vh",
          border: "none",
        }}
      />
    );
  }

  if (previewLinkData?.thumbnail_url) {
    return (
      <img
        style={{
          display: "block",
          marginLeft: "auto",
          marginRight: "auto",
        }}
        src={previewLinkData.thumbnail_url}
        alt="Preview Thumbnail"
      />
    );
  }

  return (
    <div
      className="alert alert-warning"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
      }}
    >
      This preview isn't available right now. Please try again later.
    </div>
  );
};

const withLinksInNewTab = (html) => {
  const base = '<base target="_blank">';
  if (/<head(\s[^>]*)?>/i.test(html)) {
    return html.replace(/<head(\s[^>]*)?>/i, (head) => head + base);
  }
  return base + html;
};
